import React from "react";
import Cotizadores from "../../components/Cotizadores/Cotizadores";
import CotizadoresLista from "../../components/Cotizadores/CotizadoresLista";

const ContainerCotizadores = () =>
  <main className="bg-light">
    <div className="cr-content container-fluid">
      <div className="container-body-spaces">
        <CotizadoresLista />
      </div>
    </div>
  </main>



export default ContainerCotizadores
